/*
 * Copyright (c) 2024 CalAmp Corp.  All Rights Reserved
 */
import React, {MouseEvent, useCallback} from 'react';
import {Link} from '@ion/core/src/types/entities';
import IdentifierMoreCount from './IdentifierMoreCount';

export interface DeviceGroupInheritableTitleType {
  groups?: Link[];
  onGroupClick?: (group: Link) => void;
  setShowDialog?: (showDialog: boolean) => void;
  groupSections?: string;
  groupLength?: number;
  itemLength?: number;
  moreItem?: number;
};

/**
 * Defines the DeviceGroupInheritableTitle component. This component is used to
 * display the group names with tooltip when we click on more groups link
 *
 * ```typescript
 *
 *   import DeviceGroupInheritableTitle from './DeviceGroupInheritableTitle';
 *
 *   <DeviceGroupInheritableTitle  groups={groups} />
 *
 * ```
 */
const DeviceGroupInheritableTitle = ({
  groups,
  groupLength,
  groupSections,
  onGroupClick,
  setShowDialog,
  itemLength,
  moreItem
}: DeviceGroupInheritableTitleType) => {
  const onTitleClick = useCallback((group: Link) => (e: MouseEvent<HTMLDivElement>) => {
    onGroupClick(group);
  }, []);

  if (groupLength) {
    return (
      <>
        {groups?.map?.((group, index) => (
          <div key={index}
            className={groupSections}
            onClick={onTitleClick(group)}>
            <span>{group?.title}</span>
          </div>
        ))}
        <IdentifierMoreCount dataSections={groupSections}
          setShowDialog={setShowDialog}
          itemLength={itemLength}
          moreItem={moreItem} />
      </>
    );
  }
  return <div />;
};

export default DeviceGroupInheritableTitle;
